"use client";

import { DotsHorizontalIcon } from "@radix-ui/react-icons";
import { Row } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import Link from "next/link";
import { CraftOpportunity } from "./craft-columns";
import { useRouter } from "next/navigation";
import { useToast } from "@/components/ui/use-toast";
import axios from "axios";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActionsCraft<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const router = useRouter();
  const opportunity = row.original as CraftOpportunity;
  const leadId = opportunity.assigned_leads?.id;
  const { toast } = useToast();

  const onHideToggle = async () => {
    try {
      const response = await axios.put(`/api/crm/opportunity/hide/${opportunity.id}`);
      toast({
        title: "Success",
        description: response.data.message,
      });
      router.refresh();
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Something went wrong while toggling visibility. Please try again.",
      });
    }
  };

  return (
    <div className="flex gap-2 items-center">
      {leadId ? (
        <Link href={`/crm/leads/${leadId}`}>
          <Button variant="outline" size="sm">
            View
          </Button>
        </Link>
      ) : (
        <Button variant="outline" size="sm" disabled>
          No Lead
        </Button>
      )}
      
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            className="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
          >
            <DotsHorizontalIcon className="h-4 w-4" />
            <span className="sr-only">Open menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-[160px]">
          <DropdownMenuItem onClick={onHideToggle}>
            Hide
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
} 